type InfoCircleIconProps = {
  color?: string;
  size?: number;
}

export const InfoCircleIcon = ({ color = 'white', size = 20 }: InfoCircleIconProps): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="9" stroke={color} strokeWidth="1.6" />
    <circle cx="10" cy="6.5" r="1" fill={color} />
    <line x1="10" y1="9.5" x2="10" y2="14.5" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);
